import {VccCredentialsListItem} from '../../../integrated-client/models/';

interface ITableData {
  records: Array<VccCredentialsListItem>
}

export class TableData implements ITableData{
  records: Array<VccCredentialsListItem>

  constructor() {
    this.records = [];
  }

}
